import { ArgumentNullException } from '../../../../utility/exception/argument-null.exception';
import { IdValueObject } from '../../../../utility/model/id-value-object.model';

export class SharingVendorFileStorageLink extends IdValueObject {
  static create(value: string): SharingVendorFileStorageLink {
    if (value === null) {
      throw new ArgumentNullException();
    }
    return new SharingVendorFileStorageLink(value);
  }
}
